import React from "react";
import { FiCheckCircle, FiClock } from "react-icons/fi";

export default function EventStatusBadge({ active }) {
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-xs font-bold ${
        active
          ? "border-emerald-200 bg-emerald-50 text-emerald-700 dark:border-emerald-500/20 dark:bg-emerald-500/10 dark:text-emerald-300"
          : "border-amber-200 bg-amber-50 text-amber-700 dark:border-amber-500/20 dark:bg-amber-500/10 dark:text-amber-300"
      }`}
    >
      {active ? <FiCheckCircle /> : <FiClock />}
      {active ? "Publié" : "Brouillon"}
    </span>
  );
}